import React from "react";
import styles from "./ExpensesTab.module.css";

const EXPENSE_TYPE_LABELS = {
  Rent: "إيجار",
  Utilities: "مرافق",
  Supplies: "مستلزمات",
  Maintenance: "صيانة",
  SalaryAndCommission: "رواتب وعمولات",
  Other: "أخرى",
};

const ExpenseTable = ({ expenses, onEdit, onDelete }) => {
  if (!expenses.length) return <div className={styles.empty}>لا يوجد مصروفات مطابقة</div>;

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>العنوان</th><th>النوع</th><th>المبلغ</th>
            <th>الموظف المرتبط</th><th>تاريخ المصروف</th><th>ملاحظات</th><th>إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {expenses.map((exp) => (
            <tr key={exp.id}>
              <td>{exp.title}</td>
              <td>
                <span className={styles.typeBadge}>
                    {EXPENSE_TYPE_LABELS[exp.expenseType] || exp.expenseType}
                </span>
                </td>
              <td className={styles.amount}>{exp.amount?.toLocaleString()} ج.م</td>
              <td>{exp.employeeName || "—"}</td>
              <td>{new Date(exp.expenseDate).toLocaleDateString("ar-EG")}</td>
              <td className={styles.notesCell}>{exp.notes || "—"}</td>
              <td className={styles.actionsCell}>
                <button className={styles.editBtn} onClick={() => onEdit(exp)}>تعديل</button>
                <button className={styles.deleteBtn} onClick={() => onDelete(exp)}>حذف</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ExpenseTable;